import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ProductHeader } from './components/ProductHeader';
import { Home } from './pages/Home';
import { RecommendationDetail } from './pages/RecommendationDetail';
import { SavedRecommendations } from './pages/SavedRecommendations';
import { BusinessProfile } from './pages/BusinessProfile';
import { ConsumerProfile } from './pages/ConsumerProfile';
import { CategoryExplore } from './pages/CategoryExplore';
import { CityExplore } from './pages/CityExplore';
import { CategoriesIndex } from './pages/CategoriesIndex';
import { CitiesIndex } from './pages/CitiesIndex';
import { AuthScreen } from './components/AuthScreen';
import { AuthProvider, useAuth } from './context/AuthContext';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="skeleton" style={{ width: 40, height: 40, borderRadius: '50%' }} />
      </div>
    );
  }
  
  return user ? <>{children}</> : <Navigate to={`/auth?next=${encodeURIComponent(location.pathname)}`} replace />;
}

export function DiscoveryApp() {
  return (
    <AuthProvider>
      <div className="flex flex-col min-h-screen discovery-app-shell">
        <ProductHeader />
        <main className="flex-1 discovery-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/recommendations/:id" element={<RecommendationDetail />} />
            <Route path="/businesses/:id" element={<BusinessProfile />} />
            <Route path="/categories" element={<CategoriesIndex />} />
            <Route path="/categories/:id" element={<CategoryExplore />} />
            <Route path="/cities" element={<CitiesIndex />} />
            <Route path="/cities/:id" element={<CityExplore />} />
            <Route path="/profile" element={<PrivateRoute><ConsumerProfile /></PrivateRoute>} />
            <Route path="/auth" element={<AuthScreen />} />
            <Route
              path="/saved"
              element={
                <PrivateRoute>
                  <SavedRecommendations />
                </PrivateRoute>
              }
            />
            <Route path="/auth/callback" element={<AuthScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  );
}
